import React, { PropsWithChildren } from "react";

import { Typography, TypographyProps } from "@mui/material";

export interface ColoredTextProps extends TypographyProps, PropsWithChildren {
  color: "tangerine" | "green";
}

export const colors = {
  tangerine: ["#FFE0B3", "#E65200"],
  green: ["#C7E6C9", "#1C5E20"],
};

const ColoredText: React.FC<ColoredTextProps> = ({
  color,
  children,
  ...props
}) => {
  return (
    <Typography
      sx={{
        bgcolor: colors[color][0],
        color: colors[color][1],
        borderRadius: 1,
        px: 1,
        py: 0.25,
      }}
      variant="body2"
      {...props}
    >
      {children}
    </Typography>
  );
};

export default ColoredText;
